"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Underline = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Underline = function Underline() {
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6 0H19.2C19.6418 0 20 0.358172 20 0.8V9.6C20 14.0183 16.4183 17.6 12 17.6C7.58171 17.6 3.99999 14.0183 3.99999 9.6V0.8C3.99999 0.358172 4.35816 0 4.79999 0H6.39999C6.84182 0 7.19999 0.358172 7.19999 0.8V9.6C7.19999 12.251 9.34902 14.4 12 14.4C14.651 14.4 16.8 12.251 16.8 9.6V0.8C16.8 0.358172 17.1582 0 17.6 0ZM23.2 23.2V21.6C23.2 21.1582 22.8418 20.8 22.4 20.8H1.59999C1.15816 20.8 0.799988 21.1582 0.799988 21.6V23.2C0.799988 23.6418 1.15816 24 1.59999 24H22.4C22.8418 24 23.2 23.6418 23.2 23.2Z"
  }));
};

exports.Underline = Underline;